export const UI_SECRET_KEYS = {
  GOOGLE_MAPS_API_KEY: 'googleMapsApiKey',
} as const;
